import Join, { JoinProps } from '../Join'

export type PaginationProps = JoinProps
const Pagination = Join
export default Pagination
